/**
 * BKA Routes
 *
 * Route definitions for the BKA (Betriebskostenabrechnung) module.
 */

import { lazy } from 'react';

const BKAManagement = lazy(() => import('@/pages/bka/BKAManagement'));
const BKACreationPage = lazy(() => import('@/pages/bka/BKACreationPage'));
const BKADetailView = lazy(() => import('@/pages/bka/BKADetailView'));

export const bkaRoutes = [
    {
        path: 'bka',
        element: <BKAManagement />,
    },
    {
        path: 'bka/create',
        element: <BKACreationPage />,
    },
    {
        path: 'bka/:id/edit',
        element: <BKACreationPage />,
    },
    {
        path: 'bka/:id',
        element: <BKADetailView />,
    },
];
